import { FC, useState } from 'react';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';

import { markAsRead, markAsUnread } from 'features/news/actions';
import { getUserProfile } from 'features/user/actions';

import { language } from 'utils';

import { useAppDispatch, useTranslate } from 'hooks';

import { INewsTitle } from 'models';

import { Popover } from '../Popover';

import styles from './index.module.scss';

const DELAY = 500;

export const MarkDot: FC<{ item: INewsTitle; isDropdown?: boolean }> = ({ item, isDropdown }) => {
	const { markAsReadText, markAsUnreadText } = useTranslate(['markAsReadText', 'markAsUnreadText']);

	const dispatch = useAppDispatch();

	const [isAnimating, setIsAnimating] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const startAnimation = () => {
		if (!isAnimating) {
			setIsAnimating(true);

			setTimeout(() => {
				setIsAnimating(false);
			}, DELAY);
		}
	};

	const onClick = (item: INewsTitle) => {
		if (isSubmitting) return;
		setIsSubmitting(true);
		startAnimation();
		const callback = item.read ? markAsUnread : markAsRead;

		dispatch(callback({ lang: language, newsUuid: item.id })).finally(() => {
			setIsSubmitting(false);
			dispatch(getUserProfile());
		});
	};

	return (
		<Popover
			isButton
			content={item.read ? markAsUnreadText : markAsReadText}
			className={styles.popover}
			placement={isMobile && isDropdown ? 'topRight' : 'top'}
		>
			<div
				content={item.read ? markAsUnreadText : markAsReadText}
				className={classNames(styles.dot, {
					[styles.grey]: item.read,
					[styles.animation]: isAnimating,
				})}
				role="button"
				style={{ pointerEvents: isSubmitting ? 'none' : 'unset' }}
				onClick={(e) => {
					e.preventDefault();
					onClick(item);
				}}
			/>
		</Popover>
	);
};
